import { createSelector } from 'reselect'
import { selectors as imported } from '../../imports'

export const getUiVersions = state => state.syncReducer.versions
export const getUiVersion = createSelector(
    [imported.getLauncherType, getUiVersions],
    (launcherType, uiVersions) => uiVersions[launcherType] || '-1',
)



// WEBPACK FOOTER //
// ./src/features/Sync/data/versions/selectors.js